import { render, staticRenderFns } from "./ContextMenuCustomForTextArea.vue?vue&type=template&id=1218cfe5&scoped=true&"
import script from "./ContextMenuCustomForTextArea.vue?vue&type=script&lang=js&"
export * from "./ContextMenuCustomForTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuCustomForTextArea.vue?vue&type=style&index=0&id=1218cfe5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218cfe5",
  null
  
)

export default component.exports